import endpoints from '@/api/endpoints';
import { http, HttpResponse } from 'msw';

const API_BASE_URL = endpoints.baseURL;

// IB1-mock : mocks globaux (persistants, utilisés aussi par le worker MSW navigateur en dev, voir
// src/mocks/browser.ts) pour compléter le parcours "Request Checkbook" au-delà de la sélection du
// type — jusqu'ici seuls des mocks *ephémères* existaient, déclarés par test via
// nodeServiceWorker.use() dans checkbookRequestFlowFixtures.ts. Sans ceux-ci, le formulaire reste
// bloqué en dev local dès l'étape suivante (calcul des frais), même une fois checkbookTypes peuplé.
// Frais alignés sur les types mockés dans handlers/user/index.ts (getBankInfoHandler).
const FEES_BY_TYPE_CODE: Record<string, { operationFee: string }> = {
  'STD-USD': { operationFee: '5000' },
  'BUS-USD': { operationFee: '10000' },
  'STD-SSP': { operationFee: '5000' },
  'BUS-EUR': { operationFee: '45' },
};

export const getCheckbookFeesHandler = http.get<{ code: string }, any, any>(
  `${API_BASE_URL}${endpoints.checkbookFees(':code')}`,
  ({ params }) => HttpResponse.json(FEES_BY_TYPE_CODE[params.code] ?? { operationFee: '5000' })
);

// Endpoint générique partagé par tout parcours MFA (transferts, virement, chéquier, etc.) — aucun
// mock global n'existait avant, seulement des overrides ephémères par test.
export const createMfaChallengeHandler = http.post(`${API_BASE_URL}${endpoints.createMfaChallenge}`, () =>
  HttpResponse.json({ challengeId: 'challenge-mock', codeExpiresInSeconds: 300, sendAttemptsLeft: 3 })
);

export const requestCheckbookHandler = http.post(`${API_BASE_URL}${endpoints.requestCheckbook}`, () =>
  HttpResponse.json({ id: 'chk-new-mock' }, { status: 201 })
);

export const checkbookRequestFlowHandlers = [getCheckbookFeesHandler, createMfaChallengeHandler, requestCheckbookHandler];
